import useLoad from 'components/hooks/useLoad';
import {profile} from 'constants/url';

function useLoadProfiles() {
  return useLoad(profile, 'iD_Profile', {});
}

export default useLoadProfiles;
